import React from "react";
import { X, KeyRound } from "lucide-react";
import { RegisterForm } from "../../../../components/RegisterForm";
import ForgotPasswordForm from "../../../../components/ForgotPasswordForm";
import ResetPasswordForm from "../../../../components/ResetPasswordForm";
import { VerifyEmailPrompt } from "../../../../components/VerifyEmailPrompt";
import { getModalPanelClasses, getOverlayClasses } from "../modalClasses";

export const AuthModalHost = ({
  isModalOpen,
  activeModal,
  isRegisterModal,
  isVerificationModal,
  closeModal,
  openModal,
  handleCloseResetModal,
  handleResetSuccess,
  resetModal,
  verificationEmail,
  onShowVerificationModal,
}) => {
  const overlayClasses = getOverlayClasses(isModalOpen);
  const modalPanelClasses = getModalPanelClasses(isModalOpen);

  return (
    <div
      className={`pointer-events-none fixed inset-0 z-50 flex items-center justify-center bg-slate-900/80 backdrop-blur-sm transition ${overlayClasses}`}
      aria-hidden={!isModalOpen}
    >
      <div className={`pointer-events-auto relative w-full max-w-xl ${modalPanelClasses}`}>
        {isRegisterModal ? (
          <div className="relative overflow-hidden rounded-3xl border border-white/20 bg-white/95 shadow-[0_35px_120px_-45px_rgba(15,23,42,0.8)] backdrop-blur-2xl">
            <RegisterForm
              embedded
              onSwitchToLogin={closeModal}
              onVerificationReady={onShowVerificationModal}
            />
            <CloseButton onClose={closeModal} />
          </div>
        ) : activeModal === "forgot" ? (
          <ForgotPasswordModal onClose={closeModal} />
        ) : isVerificationModal ? (
          <VerifyEmailPrompt embedded defaultEmail={verificationEmail} onClose={closeModal} />
        ) : activeModal === "reset" ? (
          <ResetPasswordForm
            embedded
            uid={resetModal?.uid}
            token={resetModal?.token}
            onClose={handleCloseResetModal}
            onSuccess={handleResetSuccess}
            onRequestResetLink={() => openModal("forgot")}
          />
        ) : null}
      </div>
    </div>
  );
};

const CloseButton = ({ onClose }) => (
  <button
    type="button"
    onClick={onClose}
    className="absolute top-4 right-4 z-30 flex h-10 w-10 items-center justify-center rounded-2xl bg-slate-900/95 text-white shadow-lg shadow-slate-900/30 transition hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-2 focus:ring-offset-white"
    aria-label="Close"
  >
    <X size={18} />
  </button>
);

const ForgotPasswordModal = ({ onClose }) => (
  <div className="relative mx-auto w-full max-w-md rounded-2xl border border-white/20 bg-white/95 p-6 text-slate-900 shadow-[0_35px_120px_-45px_rgba(15,23,42,0.8)] backdrop-blur-2xl sm:p-8">
    <CloseButton onClose={onClose} />
    <div className="space-y-6">
      <div className="space-y-2 text-center">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-900 text-white shadow-lg shadow-slate-900/30">
          <KeyRound size={28} />
        </div>
        <h2 className="text-2xl font-semibold text-slate-900">Reset your password</h2>
        <p className="text-sm text-slate-500">Enter the email and we will send a reset link.</p>
      </div>
      <ForgotPasswordForm embedded />
    </div>
  </div>
);

